import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export const ExtraPermissionsMessage = ({ marginTop }) => {
  const { t } = useTranslation('strings');

  return (
    <div style={{ marginTop, backgroundColor: '#f5f5f5', border: '1px solid #9e9e9e', padding: '8px' }}>
      {t('dataPrivacyLawMessage')}
    </div>
  );
};

ExtraPermissionsMessage.propTypes = {
  marginTop: PropTypes.string.isRequired,
};
